import { css } from "lit";
const TRANSITION_TIME = 0.2;
const styles = css`
  :host {
    --toggle-width: 48px;
    --toggle-border: 3px;
    display: inline-flex;
  }

  :host([dsf_size='small']) {
    --toggle-width: 32px;
    --toggle-border: 2px;
  }

  .toggle {
    position: relative;
    display: inline-block;
    width: var(--toggle-width);
    height: calc(var(--toggle-width) / 2);
  }

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + .slider:before {
    transform: translateX(calc(var(--toggle-width) / 2));
  }

  :host(:not([disabled])) .slider {
    cursor: pointer;
    background: rgb(var(--dsf-color-neutral-100));
  }

  :host(:not([disabled])) .slider:before {
    cursor: pointer;
    background-color: rgb(var(--dsf-color-neutral-0));
  }

  :host(:not([disabled])) .slider:hover {
    background: rgb(var(--dsf-color-neutral-200));
  }

  :host(:not([disabled])) input:checked + .slider {
    background: rgb(var(--dsf-color-secondary-200));
  }

  :host(:not([disabled])) input:checked + .slider:hover {
    background: rgb(var(--dsf-color-secondary-400));
  }

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: background-color ${TRANSITION_TIME}s ease-out;
    border-radius: calc(var(--toggle-width) / 2);
    background: rgb(var(--dsf-color-neutral-100));
  }

  .slider:before {
    position: absolute;
    content: '';
    height: calc(var(--toggle-width) / 2 - var(--toggle-border) * 2);
    width: calc(var(--toggle-width) / 2 - var(--toggle-border) * 2);
    left: var(--toggle-border);
    bottom: var(--toggle-border);
    background-color: rgb(var(--dsf-color-neutral-200));
    transition: background-color, transform ${TRANSITION_TIME}s ease-out;
    border-radius: 50%;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  }
`;
export {
  styles
};
